<template>
  <div class="app-community flex">
    <GfrLayoutAside class="app-community-menu" :data-state="showMenu ? 'open' : 'closed'">
      <div class="app-community-aside-inner">
        <div class="mb-6 flex items-center flex-shrink-0">
          <GfrNewButton class="app-toggle-btn" @click="toggleCommunityMenu">
            <IconsReturn class="h-6 w-6 rotate-180" />
          </GfrNewButton>
        </div>
        <GfrScrollArea
          v-model:reset="resetScroll"
          class="app-docs-catalog-wrapper"
          :dir="$route.params.lang === 'ar' ? 'rtl' : 'ltr'"
        >
          <GfrCatalogNew
            :data="communityMenu"
            :active-url="String($route.params.category)"
            :show-obsoleted="false"
            :prefix-path="`/${$route.params.lang}/community`"
          />
        </GfrScrollArea>
      </div>
    </GfrLayoutAside>
    <section class="app-community-inner">
      <NuxtPage v-if="communityMenu.length" />
    </section>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const communityStore = useCommunityStore()
const { toggleCommunityMenu, fetchCommunityData } = communityStore
const { showMenu, communityMenu } = storeToRefs(communityStore)
const firstIntState = ref(false)
const resetScroll = ref(false)
await fetchCommunityData()

const autoPageJump = () => {
  if (communityMenu.value.length > 0) {
    const firstCategory = communityMenu.value[0]?.url
    const currentCategory = route.params.category as string
    const isCurrentInMenu = currentCategory ? communityMenu.value.some((item) => item.url === currentCategory) : false
    // 没有 category 或当前 category 不在菜单中时，跳转到第一个分类
    if (firstCategory && (!currentCategory || !isCurrentInMenu)) {
      navigateTo({
        path: `/${route.params.lang}/community/${firstCategory}`,
        replace: true
      })
    }
  }
}

watch(
  () => route.params.category,
  () => {
    showMenu.value && toggleCommunityMenu()
    const category = route.params.category
    if (!category && firstIntState.value) {
      autoPageJump()
    }
  }
)
onMounted(() => {
  autoPageJump()
  firstIntState.value = true
})
</script>

<style scoped lang="scss">
.app-community-inner {
  @apply w-full pb-13 pt-6 px-10;
}
.app-community-menu {
  // layout
  @apply w-full;
  background-color: #000;

  // spacing & position（移动端横屏样式作为默认）
  @apply z-[22] fixed left-0 top-[84px] h-[calc(100%-5.25rem)] w-full px-10 py-6;

  // background overlay
  @apply after:absolute after:top-0 after:-z-10 after:h-full after:w-full;
  @apply after:rtl:left-0 after:ltr:right-0 after:bg-[#202227];

  // animation
  @apply transition-transform duration-500 ease-out data-[state=open]:pointer-events-auto ltr:data-[state=closed]:-translate-x-full ltr:data-[state=open]:translate-x-0 rtl:data-[state=closed]:translate-x-full rtl:data-[state=open]:translate-x-0;

  :deep(.gfr-catalog-header) {
    @apply py-[13px] mb-4;
  }
}
.app-community-menu-inner {
  @apply flex lg:max-h-[calc(100vh-6.5rem)] w-[19.5rem] flex-col pb-7 lg:sticky lg:left-0 lg:top-24;
  @apply max-lg:w-full max-lg:h-full max-lg:max-h-[98%] max-lg:pb-2;
}
.app-toggle-btn {
  @apply inline-flex z-10 h-11 w-11 bg-dark-background ltr:mr-2 rtl:ml-2;
}
.app-community-aside-inner {
  @apply flex  flex-col pb-7;
  @apply w-full h-full max-h-[98%] pb-2;
}
</style>
